import { render } from "./Formulaire.vue?vue&type=template&id=b6f5d6a0&scoped=true"
import script from "./Formulaire.vue?vue&type=script&lang=js"
export * from "./Formulaire.vue?vue&type=script&lang=js"

import "./Formulaire.vue?vue&type=style&index=0&id=b6f5d6a0&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6f5d6a0"]])

export default __exports__